var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"import-step-container content-container red"},[_c('v-icon',{staticClass:"mr-2",attrs:{"color":"white","size":"100"}},[_vm._v(" mdi-alert-circle ")]),_vm._v(" "+_vm._s(_vm.importError)+" ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }